"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollNavButton = void 0;
var React = require("react");
var Icons_1 = require("../../../_Core/Icons");
var Icons_2 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var ScrollNavButton_styles_1 = require("./ScrollNavButton.styles");
var ScrollNavButton = function (_a) {
    var Type = _a.Type, Show = _a.Show, Disabled = _a.Disabled, OnClick = _a.OnClick;
    var icon = Type === "Next" ? Icons_1.Icons.ChevronRight : Icons_1.Icons.ChevronLeft;
    var ariaLabel = Type === "Next" ?
        Localization_1.strings.ProgressTracker_Action_ViewNextStep :
        Localization_1.strings.ProgressTracker_Action_ViewPreviousStep;
    var handleOnClick = function () {
        OnClick();
    };
    return (React.createElement(ScrollNavButton_styles_1.StyleButton, { Show: Show, Disabled: Disabled, Type: Type, type: "button", "aria-label": ariaLabel, disabled: Disabled, onClick: handleOnClick },
        React.createElement(ScrollNavButton_styles_1.ScrollNavButtonIconSpan, { Disabled: Disabled },
            React.createElement(Icons_2.Icon, { Icon: icon }))));
};
exports.ScrollNavButton = ScrollNavButton;
